import CookiePage from './../page/CookiePage.js';
import Cookie from '@templates/App/Cookies.js';

const CookieBar = {

	forbiddenUrls: [
		'cookies',
		'privacy-policy',
		'osobne-udaje-a-cookies',
	],

	init() {
		this.el = $('[component="CookieBar"]');
		if (!this.el.length) return;

		this.forbiddenUrls =  window.T && window.T.cookies_bar_forbiddenUrls || [];
		this.cookieToggle = $('a.cookieBar-toggle');
		this.agreeButton = this.el.find('button.agree');
		this.declineButton = this.el.find('.button.decline');
		this.closeButton = this.el.find('.close');
		this.bind();
		this.show();
	},

	bind() {
		this.cookieToggle.on('click', CookieBar.open);
		this.agreeButton.on('click', CookieBar.agree);
		this.declineButton.on('click', CookieBar.decline);
		this.closeButton.on('click', CookieBar.hide);
	},

	agree() {
		CookiePage.acceptAllCookies();
		CookieBar.hide();
	},

	decline() {
		CookiePage.acceptEssentialCookies();
		CookieBar.hide();
	},

	show() {
		const url = window.location.pathname.split('/').slice(-1).toString();

		if (Cookie.get(CookiePage.cookieName) || this.forbiddenUrls.includes(url))
			return;

		this.open();
	},

	open() {
		CookieBar.el.addClass('visible');
	},

	hide() {
		CookieBar.el.removeClass('visible');
	},
};
export default CookieBar;